import styled from 'styled-components';

import { sizeUp } from '~/theme';
import StepNumber from '~atoms/StepNumber';

const attrDisabled = '[disabled]';
const attrDataIsHighlighted = '[data-is-highlighted="true"]';
const attrDataIsCurrent = '[data-is-current="true"]';

export const Content = styled.span(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '10rem',

  position: 'relative',

  textAlign: 'left',
  textTransform: 'uppercase',
  fontSize: theme.typography.size16,
  fontFamily: theme.typography.family.arial,
  color: 'inherit',

  transition: 'inherit',
}));

export const Container = styled.button(({ theme }) => ({
  paddingBlock: 0,
  paddingInline: sizeUp('15rem', ['1360rem', '23rem']),
  minHeight: sizeUp('45rem', ['1360rem', '53rem']),
  borderRadius: '15rem',
  border: 'none',
  background: 'transparent',

  color: theme.palette.desertSand,

  cursor: 'pointer',

  transition: ['250ms color linear', '250ms background linear'].join(', '),

  [`${StepNumber}`]: {
    transition: 'inherit',
    color: theme.palette.white,
    background: theme.palette.desertSand,
    borderColor: 'transparent',
  },

  [`&${attrDataIsHighlighted}, &${attrDataIsCurrent}, &:not(${attrDisabled}):hover`]:
    {
      background: theme.palette.desertSand,
      color: theme.palette.darkLiver,

      [`${Content}`]: {
        fontWeight: 'bold',
      },

      [`${StepNumber}`]: {
        color: 'inherit',
        borderColor: 'inherit',
      },
    },

  [`&${attrDisabled}`]: {
    cursor: 'not-allowed',
  },
}));
